export const rowdetails = {
  root: {
    padding: "0",
  },
  table: {
    padding: "{datatable.body.cell.padding}",
    background: "{surface.bg-grey-contrast}",
  },
  row: {
    borderWidth: "0 0 {border.width.1} 0",
    borderColor: "{surface.border}",
  },
  cell: {
    padding: "{datatable.body.cell.padding}",
  },
  term: {
    fontWeight: "{typography.table.heading.font.weight}",
  },
};
